import { EvsRecord } from './evsRecord';

export interface IExamen {
  id: string;
  type: string;
  date: string;
  result: string;
  cancelled_at: string;
}

export class ExamenModel extends EvsRecord implements IExamen {
  id: string;
  type: string;
  date: string;
  result: string;
  cancelled_at: string;

  constructor(obj: IExamen) {
    super(obj);
  }
}

export interface ShortTermExamPlanning {
  readonly eligible: boolean;
  readonly exam_express_active: boolean;
  planning: Array<SlotModel>;
}

export interface SlotModel {
  readonly formatted_date: string;
  readonly date: string;
  selected: boolean;
}
